"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../context");
const PlayerOverlayButton_1 = tslib_1.__importDefault(require("../../../ui-lib/PlayerOverlayButton"));
const ErrorBoundary_1 = require("../../ErrorBoundary");
const ModularOverlayButton = (0, mobx_react_lite_1.observer)(({ children, onClick, ...props }) => {
    const componentName = "<PlayerOverlayButton/>";
    const ctx = (0, react_1.useContext)(context_1.PlayerUiContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)((ctx === null || ctx === void 0 ? void 0 : ctx.player) != null, componentName);
    const setPlaying = () => {
        ctx.logger.info("PlayerOverlayButton clicked");
        ctx.player.localVideoPaused = false;
    };
    const handleClick = (0, ErrorBoundary_1.useUIEventError)(onClick !== null && onClick !== void 0 ? onClick : setPlaying, componentName);
    if (!ctx.player.localVideoPaused) {
        return null;
    }
    const handleMouseOver = () => {
        if (!ctx.mobileDevice) {
            ctx.videoMouseOver = true;
        }
    };
    const handleMouseOut = () => {
        if (!ctx.mobileDevice) {
            ctx.videoMouseOver = false;
        }
    };
    return (react_1.default.createElement(PlayerOverlayButton_1.default, { onMouseEnter: () => handleMouseOver(), onMouseLeave: () => handleMouseOut(), ...props, onClick: handleClick }, children));
});
// eslint-disable-next-line react/function-component-definition
const OverlayButtonWithErrorBoundary = ({ ...props }) => {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => react_1.default.createElement(PlayerOverlayButton_1.default, { ...props, disabled: true }) },
        react_1.default.createElement(ModularOverlayButton, { ...props })));
};
exports.default = OverlayButtonWithErrorBoundary;
//# sourceMappingURL=PlayerOverlayButton.js.map